<div fxLayout="column" fxFlex>  
    <h1 mat-dialog-title>Complaint Worker/Contractor</h1>
    <form [formGroup]="contractorDataForm">
        <div fxLayout="column" fxFlex>
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput type="text" placeholder="Name" formControlName="name">
            </mat-form-field>
            <mat-form-field>
                <mat-label>CCB</mat-label>
                <input matInput type="text" placeholder="CCB" formControlName="ccb">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Phone</mat-label>
                <input matInput type="text" placeholder="Phone" formControlName="phone">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Email</mat-label>
                <input matInput type="text" placeholder="Email" formControlName="email">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Street</mat-label>
                <input matInput type="text" placeholder="Street" formControlName="street">
            </mat-form-field>
            <mat-form-field>
                <mat-label>City</mat-label>
                <input matInput type="text" placeholder="City" formControlName="city">
            </mat-form-field>
            <mat-form-field>
                <mat-label>State</mat-label>
                <input matInput type="text" placeholder="State" formControlName="state">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Zip</mat-label>
                <input matInput type="text" placeholder="Zip" formControlName="zip">
            </mat-form-field>
        </div>
    </form>
   
    <div fxLayoutGap="5px">
        <button mat-raised-button (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!contractorDataForm.valid">
            {{ data.contractor?.id ? 'Update' : 'Add' }}
        </button>
    </div>
</div>
